// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"d98f71ad","66":"d142095a","72":"8e2b6e05","172":"bb4b8e05","330":"661da1b5","373":"8b053be8","394":"deb233e7","410":"f035d35e","412":"57e4e635","481":"fe90ed14","683":"90233fda","846":"013bc7fb"}[chunkId] + ".chunk.js";
};